import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout")({
    component: () => <TrackingLayout />,
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.log.tracking.title"),
        };
    },
});

function TrackingLayout() {
    return <Outlet />;
}
